<template>
  <div :class="className" @click="onClick">
    <div
      :class="
        `btn-icons ${
          colors ? 'btn-icons__default' : 'btn-icons__red'
        } ${position && 'row-reverse'}`
      "
    >
      <img :src="require(`~/assets/img/icons/${path}`)" alt="" />
      <div>{{ title }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['title', 'path', 'onClick', 'position', 'colors', 'className'],
}
</script>
